import { api } from '../helpers/api';
import { IReportVoiceParams, IRequestSMSPurchaseParams, ISummaryRequestSMSParams, ISummaryVoiceParams } from '../pages/package-sms/interfaces/apis';

const getSummaryRequestSMSPurchase = async (params: ISummaryRequestSMSParams) => {
  return await api.get('/api/v1/admin/package-sms/summary-request-purchase', { params });
};

const getRequestSMSPurchase = async (params: IRequestSMSPurchaseParams) => {
  return await api.get('/api/v1/admin/package-sms/request-purchase', { params });
};

const getSummaryVoice = async (params: ISummaryVoiceParams) => {
  return await api.get('/api/v1/admin/package-sms/summary-voice', { params });
};

const getReportVoice = async (params: IReportVoiceParams) => {
  return await api.get('/api/v1/admin/package-sms/report-voice', { params });
};

const packageSmsApis = {
  getSummaryRequestSMSPurchase,
  getRequestSMSPurchase,
  getSummaryVoice,
  getReportVoice,
};

export default packageSmsApis;